import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ApprovalModel } from 'rev-shared/media/ApprovalModel';
import { ApprovalStatusInfo } from './ApprovalStatusInfo';
import { ApprovalStepStatus } from 'rev-shared/media/MediaConstants';

import styles from './approver-request.module.less';

@Component({
	selector: 'approval-approve',
	templateUrl: './ApprovalApprove.Component.html'
})
export class ApprovalApproveComponent {
	@Input() private isMediaAdmin: boolean;
	@Input() public approvalDetails: ApprovalModel;
	@Input() public isVideoUploader: boolean;
	@Input() public statusInfo: ApprovalStatusInfo;

	@Output() private onApproveVideo: EventEmitter<void> = new EventEmitter();
	@Output() private onDeleteVideo: EventEmitter<void> = new EventEmitter();
	@Output() private onRejectVideo: EventEmitter<void> = new EventEmitter();

	public readonly styles = styles;

	private get isApprovalStepPending(): boolean {
		return this.approvalDetails.stepStatus === ApprovalStepStatus.PENDING;
	}

	private get isApprovalStepOwner(): boolean {
		return this.approvalDetails.isStepApprover;
	}

	public get showActionButtons(): boolean {
		return (this.isApprovalStepOwner || this.isMediaAdmin)
			&& this.isApprovalStepPending;
	}

	public rejectVideo(): void {
		this.onRejectVideo.emit();
	}

	public approveVideo(): void {
		this.onApproveVideo.emit();
	}

	public deleteVideo(): void {
		this.onDeleteVideo.emit();
	}
}
